module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAeBAMAAACoBpHTAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABXRSTlMAu/ke80L4GwwAAAAnSURBVCjPYzBUDUUHQcIMoqGYIJDBFYtoCHa1OMwdvGA0HAZN6AAARz1jN7u6EkgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/list.png
// module id = QsfB
// module chunks = 0